import EmptyLayout from './EmptyLayout';
import MainLayout from './MainLayout';

const LogoComponent = () => <div className="logo"/>;
const footerText = `©${new Date().getFullYear()} BÜV`;

export {MainLayout, EmptyLayout, footerText, LogoComponent};
